import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class CheckoutService {
  constructor(private http: HttpClient) {}

  reservarButacas(alias: string, payload: any) {
    console.log('reservarButacas:', payload);
    return this.http.post(`${environment.providersApiUrl}/services/${alias}/reserve`, payload);
  }

  crearPasajero(pasajero: any) {
    console.log('pasajero:', pasajero);
    return this.http.post(`${environment.backendApiUrl}/passengers`, pasajero);
  }
  
  crearOperacion(operacion: any) {
    console.log('operacion:', operacion);
    return this.http.post(`${environment.backendApiUrl}/operations`, operacion);
  }

  actualizarOperacion(id: string, operacion: any) {
    console.log('actualizarOperacion:', operacion);
    return this.http.put(`${environment.backendApiUrl}/operations/${id}`, operacion);
  }
  
  actualizarCampoOperacion(id: number, campo: string, valor: any) {
    console.log('actualizarCampoOperacion:', { [campo]: valor });
    return this.http.put(`${environment.backendApiUrl}/operations/${id}`, { [campo]: valor });
  }
  
  crearTicket(ticket: any) {
    console.log('ticket:', ticket);
    return this.http.post(`${environment.backendApiUrl}/tickets`, ticket);
  }
  actualizarTicket(id: string, ticket: any) {
    console.log('actualizarTicket:', ticket);
    return this.http.put(`${environment.backendApiUrl}/tickets/${id}`, ticket);
  }
  asociarTicket(ticketId: number, operationId: number) {
    console.log('asociarTicket:', ticketId, operationId);
    return this.http.post(`${environment.backendApiUrl}/tickets/${ticketId}/associate-operation/${operationId}`, {});
  }


  confirmarPago(operationId: number) {
    console.log('confirmarPago:', operationId);
    return this.actualizarCampoOperacion(operationId, 'operation_status_id', 2);
  }

}
